import StorageHelper from 'Stores/helper';

const scope = 'CAMPAIGNS/advocate';

const defaultState = {
    id: null,
    firstName: '',
    lastName: '',
};

const mod = {
    namespaced: true,
    state: {
        id: null,
        firstName: null,
        lastName: null,
        twitterCredentialsSaved: false,
    },
    mutations: {
        id: (state, id) => {
          state.id = id;
        },
        firstName: (state, firstName) => {
          state.firstName = firstName;
        },
        lastName: (state, lastName) => {
          state.lastName = lastName;
        },
        twitterCredentialsSaved: (state, bool) => {
          state.twitterCredentialsSaved = bool;
        },
    },
    actions: {
        id({ commit }, id) {
            StorageHelper.setLocalStorageVar(commit, id, 'id', scope);
        },
        firstName({ commit }, firstName) {
            StorageHelper.setLocalStorageVar(commit, firstName, 'firstName', scope);
        },
        lastName({ commit }, lastName) {
            StorageHelper.setLocalStorageVar(commit, lastName, 'lastName', scope);
        },
        twitterCredentialsSaved({ commit }, bool) {
            commit('twitterCredentialsSaved', bool);
        },
    },
    getters: {
        id(state) {
            return state.id;
        },
        firstName(state) {
            return state.firstName;
        },
        lastName(state) {
            return state.lastName;
        },
        twitterCredentialsSaved(state) {
            return state.twitterCredentialsSaved;
        },

    },
};

export default mod;
